import React, { FC } from 'react';
import styled from 'styled-components';
import TrashIcon from '@mui/icons-material/DeleteOutlined';

import { IconButtonRounded, SkeletonLoader } from '../UI';
import { GrantAccessLevelToDisplayNameMap } from '../../constants';

interface AccessListProps {
  list: any[];
  isLoading?: boolean;
  onAction: (action: NgAction<any>) => void;
}

const StyledAccessList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;

  .loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: ${({ theme }) => theme.spacing.medium};
  }
`;

const StyledGrantItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing.small} ${({ theme }) => theme.spacing.medium};
  border-radius: ${({ theme }) => theme.radius.small};

  .actions {
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.medium};
  }

  &:hover {
    background-color: ${({ theme }) => theme.palette.grey};
  }

  h4 {
    margin: 0;
  }

  button {
    svg {
      stroke: none;
    }

    &:hover {
      svg {
        stroke: none;
        color: ${({ theme }) => theme.palette.warning};
        transition: all 0.3s ease-in-out;
      }
    }
  }
`;

export const AccessList: FC<AccessListProps> = ({ list, isLoading, onAction }) => {
  return (
    <StyledAccessList>
      {(list || []).map((grantItem: any) => (
        <StyledGrantItem key={`${grantItem?.Type}_${grantItem?.ID}`}>
          <h4>{grantItem?.Name}</h4>

          <div className="actions">
            {grantItem?.Role && (
              <div className="acces-level">
                {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                {/*//@ts-ignore*/}
                {GrantAccessLevelToDisplayNameMap?.[grantItem.Role] || 'Unknown'}
              </div>
            )}

            <IconButtonRounded
              title="Revoke"
              icon={<TrashIcon />}
              disabled={isLoading}
              onClick={() => onAction({ type: 'REVOKE', payload: grantItem })}
              filled
            />
          </div>
        </StyledGrantItem>
      ))}

      {isLoading && <SkeletonLoader />}
    </StyledAccessList>
  );
};
